import { type ReactElement } from 'react';
import { Chip } from '@optimization/ssi-common';
import { NotAvailable } from '../../../NotAvailable';

interface SpecificationCellProperties {
  readonly customer: string;
}

const MAX_CUSTOMER_LENGTH = 25;

const truncateCustomer = (customer: string): string =>
  customer.length > MAX_CUSTOMER_LENGTH ? `${customer.slice(0, MAX_CUSTOMER_LENGTH)}...` : customer;

const CustomerCell = ({ customer }: SpecificationCellProperties): ReactElement => {
  if (!customer.trim()) {
    return <NotAvailable />;
  }

  const truncated = truncateCustomer(customer);
  const isTruncated = truncated !== customer;

  return (
    <span title={isTruncated ? customer : undefined} aria-label={customer}>
      <Chip text={truncated} size="sm" />
    </span>
  );
};

export default CustomerCell;
